import * as React from 'react';

function SvgPersonOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.636, d: "M16.386 6.616c-.189 2.542-2.116 4.615-4.231 4.615-2.116 0-4.046-2.073-4.231-4.615C7.73 3.97 9.607 2 12.154 2c2.549 0 4.424 2.02 4.232 4.616z" }),
        React.createElement("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.636, d: "M12.154 14.308c-4.183 0-8.428 2.307-9.214 6.663-.094.526.203 1.03.752 1.03h16.924c.55 0 .847-.505.753-1.03-.786-4.356-5.032-6.663-9.215-6.663z" })));
}

export default SvgPersonOutline;
